import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { SeriesField } from './../../../core/types/Series';
import APCellStyles from './styles/APCell.style';
import IconButton from "@mui/material/IconButton";
import ExpandHideIcon from './assets/icons/icon-chevron-down-for-search.svg';
import ExpandMoreIcon from './assets/icons/icon-chevron-forward-for-search.svg';
import classnames from 'classnames';
import { withTranslate } from './../../../core/TenantProvider';

interface APCellProps extends WithStyles<typeof APCellStyles> {
  field: SeriesField,
  SetOpen: Function,
  responsiveClass?:string,
  translate: Function
}

interface APTradeCellState {
  open: boolean
}

class APTradeCell extends Component<APCellProps, APTradeCellState> {
  constructor(props: APCellProps) {
    super(props);
    this.state = {
      open: false
    };

    this.SetOpen = this.SetOpen.bind(this);
  }

  SetOpen = () => {
    this.setState({ open: !this.state.open }, () => {
      if (this.props.SetOpen) {
        this.props.SetOpen(this.state.open);
      }
    });
  }

  render() {
    const {
      classes,
      responsiveClass,
      field,
      translate
    } = this.props;
    const { open } = this.state;
    const isTradeHaveData = field?.fieldArrayValue && field.fieldArrayValue.events;
    return (

      isTradeHaveData ? (
        <IconButton
          className={classnames(classes.iconButton,responsiveClass)}
          aria-label="expand row"
          color="primary"
          size="medium"
          onClick={() => {
            this.SetOpen();
          }}
        >
          {translate('referrals.search.results.trades.label')} {open ? <img src={ExpandHideIcon} alt="Expand Hide Icon" className = {classes.arrowIconButton} /> : <img src={ExpandMoreIcon} alt="Expand More Icon" className = {classes.arrowIconButton}/>}
        </IconButton>
      )
        :
        ''

    );
  }
}

export default withTranslate(withStyles(APCellStyles)(APTradeCell));
